import React from "react"
import { useLocation } from "@reach/router"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function HybridLink({ linkPath, linkName, requiredPathname }) {
  const location = useLocation()

  if (location.pathname !== requiredPathname) {
    return (
      <AniLink paintDrip hex="#551864" to={linkPath}>
        {linkName}
      </AniLink>
    )
  } else {
    return <a href={linkPath}>{linkName}</a>
  }
}

export default HybridLink
